import { render, staticRenderFns } from "./PadInsabi.vue?vue&type=template&id=8bc029ce&"
import script from "./PadInsabi.vue?vue&type=script&lang=js&"
export * from "./PadInsabi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports